<template>
  <div>
    <div class="container-fluid white-bg no-shadow">
      <div class="container align-middle">
        <div class="row">
          <div class="col-12">
            <div class="land-t-delimeter" style="margin-bottom: 60px;"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <p>Компьютеризация проникла во все сферы, в том числе и в сферу образования. Современные технологии позволили внедрить дистанционное обучение детей русскому языку. Платформа HomeTeacher содержит программы, помогающие увеличить скорость чтения, курс для детей-билингвов и техники запоминания информации. Все эти знания можно получить у себя дома, выбрав понравившийся курс.</p>

            <h3 class="redh3">О платформе HomeTeacher</h3>

            <p>Зачем тратить время на скучные учебники, если методисты сети детских языковых центров Полиглотики уже проштудировали материалы, систематизировали полученную информацию и составили интересные онлайн-курсы русского языка для детей. Занятия подойдут дошкольникам, школьникам и даже родителям. Школьный класс сменила интерактивная платформа, к достоинствам которой можно отнести:</p>

            <ol>
              <li><span>Доступность обучения в любой точке мира.</span></li>
              <li><span>Поддержка квалифицированного преподавателя в течение всего процесса обучения.</span></li>
              <li><span>Увлекательные уроки-эпизоды, вспомогательные материалы и тесты.</span></li>
              <li><span>Индивидуальный темп обучения. Вы сами определяете для себя периодичность занятий.</span></li>
              <li><span>Занятия длятся от 40 до 60 минут, но вы всегда можете остановить воспроизведение видео, посмотреть урок еще раз.</span></li>
              <li><span>Демократичные цены. Обучение на онлайн-платформе выгоднее, чем очные занятия. На сайте есть возможность пройти бесплатное пробное занятие.</span></li>
            </ol>

            <p>На образовательной платформе HomeTeacher есть уникальный курс для детей-билингвов, который подойдет, например, семьям, переехавшим в другую страну. С помощью таких уроков ребенок не забудет родную речь, сможет поддерживать связь с друзьями на русском языке. Увлекательные задания будут поддерживать интерес к изучению родного языка.</p>

            <h3 class="redh3">Уникальность методики образовательного процесса составляет:</h3>

            <ul>
              <li><span>игровой формат изучения языка;</span></li>
              <li><span>обучение детей русскому языку в соответствии с авторскими методиками;</span></li>
              <li><span>контроль освоения учеником пройденного материала опытным педагогом;</span></li>
              <li><span>отработка полученных знаний на онлайн-тренажерах.</span></li>
            </ul>

            <p>Курсы по русскому языку доступны более года после приобретения. За это время ребенок запомнит новые слова, научится применять техники запоминания информации, сможет увеличить скорость чтения. Онлайн уроки русского языка для детей помогают ребенку научиться не просто беглому чтению, а вдумчивому и осмысленному восприятию текста.</p>

            <p>Важно отметить, что каждый преподаватель проходит тщательный отбор. С маленькими полиглотиками работают только преданные своему делу специалисты. Педагоги регулярно проходят курсы повышения квалификации. Все учебные материалы постоянно обновляются в соответствии с современными достижениями в области педагогики.</p>

            <p>Онлайн-школа русского языка для детей также способствует общему развитию, помогает увеличить объем памяти, учит быть внимательным. Занятия помогают в освоении школьной программы, развивают фантазию ребенка, концентрацию и вдумчивость.</p>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Lang6"
}
</script>

<style scoped>
.no-shadow p,li{color: #000; font-size: 18px;}
.no-shadow ul li{margin-bottom: 20px; padding-left: 10px;}
.no-shadow ul {list-style-image: url(~@/assets/hometeacher/images/redok.png);}
.no-shadow{margin-bottom: 70px;}
.no-shadow li{font-family: "Manrope Bold"; color:#5ab947;}
.no-shadow li span {font-family: "Manrope Light"; color: #000;}
.no-shadow ol li{margin-bottom: 20px; padding-left: 5px;}
</style>
